module.exports = __webpack_public_path__ + "img/check.21e7ebd2.svg";